import { type LabelTypeColors, type TranslationIDs, useIntl, type UserRequirementStatePvp } from '@capsicum/common';
import { useMe } from '@capsicum/socios-core';

import { REQUIREMENT_STATUS_TRANSLATION_KEY } from '../constants/requirements';
import { useGetRequirementsQuery } from '../data-access/queries/useRequirementsQueries';

export const useRequirementsPage = () => {
	const { $t } = useIntl();
	const { me } = useMe();

	const highlightPersonalVerification = me?.publicMetadata?.highlightPersonalVerification;
	const personalVerificationMenuItemBadgeColor = (
		highlightPersonalVerification ? 'red' : undefined
	) as LabelTypeColors;

	const { data: requirements, isFetching, refetch: refetchRequirements } = useGetRequirementsQuery();

	const getRequirementStatusText = (requirement: UserRequirementStatePvp) => {
		if (requirement.isExpiring) return $t(REQUIREMENT_STATUS_TRANSLATION_KEY['expiring'] as TranslationIDs);
		if (!requirement.status) return $t(REQUIREMENT_STATUS_TRANSLATION_KEY['waiting_for_user'] as TranslationIDs);

		return requirement.resubmittable && requirement.status === 'completed_deny'
			? $t(REQUIREMENT_STATUS_TRANSLATION_KEY['update'] as TranslationIDs)
			: $t(REQUIREMENT_STATUS_TRANSLATION_KEY[requirement.status] as TranslationIDs);
	};

	const isRequirementDeniedAndResubmittable = (requirement: UserRequirementStatePvp) =>
		requirement.resubmittable && requirement.status === 'completed_deny';

	return {
		getRequirementStatusText,
		isFetching,
		isRequirementDeniedAndResubmittable,
		personalVerificationMenuItemBadgeColor,
		refetchRequirements,
		requirements
	};
};
